// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acs-status-wrapper.small .verbose[class~='verbose'][data-v-6335f684] {
  margin: auto 0;
}
.acs-status-wrapper.small .additional-block[data-v-6335f684] {
  padding: 20px;
}
.acs-status-wrapper.small .entraces-toggle[class*="entraces-toggle"][data-v-6335f684] {
  margin-left: 20px !important;
}
.acs-status[data-v-6335f684] {
  padding: 10px 20px;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 58px;
  background-color: var(--content-container-bgcolor);
}
.acs-status[data-v-6335f684]:hover {
  cursor: pointer;
  background-color: var(--asc-status-hover);
}
.acs-status.verbose[data-v-6335f684]:hover {
  cursor: initial;
  background-color: initial;
}
.acs-status .head[data-v-6335f684] {
  color: var(--message-grey-color);
  font-size: 13px;
}
.acs-status .acs-status-left[data-v-6335f684] {
  display: flex;
  flex-direction: column;
  align-self: start;
  flex-grow: 1;
}
.acs-status .acs-status-left .status[data-v-6335f684] {
  color: var(--message-grey-color);
}
.acs-status .acs-status-left .status.color-accent[data-v-6335f684] {
  color: #2977c2;
}
.acs-status .acs-status-left.verbose[data-v-6335f684] {
  margin: auto 0 auto 20px;
  line-height: normal;
  font-size: 1.2em;
  color: #2977c2;
}
.acs-status .acs-status-right[data-v-6335f684] {
  display: flex;
  flex-direction: column;
  align-self: end;
  text-align: center;
  color: var(--message-grey-color);
  font-size: 0.9em;
  height: 100%;
}
.acs-status .acs-status-right.verbose[data-v-6335f684] {
  margin-right: 20px;
  font-size: 1.2em;
}
.acs-status .acs-status-right .head[data-v-6335f684] {
  white-space: pre;
  margin: auto;
}
.acs-status .acs-link[class*="acs-link"][data-v-6335f684] {
  margin: auto 0 auto 20px;
}
.acs-status .acs-link[class*="acs-link"] i[data-v-6335f684] {
  display: flex;
  margin-right: auto;
  color: var(--message-grey-color);
  font-size: 20px;
}
.acs-status .entraces-toggle[class*="entraces-toggle"][data-v-6335f684] {
  display: flex;
  margin: auto;
  border-radius: 50%;
  background-color: var(--asc-item-border-bottom);
  padding: 6px;
  width: 30px;
  height: 30px;
}
.acs-status .entraces-toggle[class*="entraces-toggle"] i[data-v-6335f684] {
  margin: auto;
  font-size: 14px;
}
.acs-spinner-wrapper[data-v-6335f684] {
  display: flex;
  min-height: 58px;
  width: 100%;
  margin: auto;
  background-color: inherit;
}
.acs-spinner-wrapper .acs-spinner[data-v-6335f684] {
  display: flex;
  margin: auto;
}
.acs-status-info[data-v-6335f684] {
  padding: 0;
}
.acs-verbose[data-v-6335f684] {
  border-bottom: 1px solid var(--asc-item-border-bottom);
  height: 58px;
}
.acs-status-placeholder[data-v-6335f684] {
  color: #ccc;
}
.additional-block[data-v-6335f684] {
  padding: 20px 40px;
}
.acs-status[data-v-6335f684]:not(:last-child),
.additional-block[data-v-6335f684]:not(:last-child) {
  box-shadow: none;
}
.acs-spinner i[data-v-6335f684] {
  font-size: 18px;
  font-weight: lighter;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/acs/AcsStatus.vue"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kDAAkD;AACpD;AACA;EACE,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,gCAAgC;AAClC;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,+CAA+C;EAC/C,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,sDAAsD;EACtD,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,oBAAoB;AACtB","sourcesContent":[".acs-status-wrapper.small .verbose[class~='verbose'][data-v-6335f684] {\n  margin: auto 0;\n}\n.acs-status-wrapper.small .additional-block[data-v-6335f684] {\n  padding: 20px;\n}\n.acs-status-wrapper.small .entraces-toggle[class*=\"entraces-toggle\"][data-v-6335f684] {\n  margin-left: 20px !important;\n}\n.acs-status[data-v-6335f684] {\n  padding: 10px 20px;\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 58px;\n  background-color: var(--content-container-bgcolor);\n}\n.acs-status[data-v-6335f684]:hover {\n  cursor: pointer;\n  background-color: var(--asc-status-hover);\n}\n.acs-status.verbose[data-v-6335f684]:hover {\n  cursor: initial;\n  background-color: initial;\n}\n.acs-status .head[data-v-6335f684] {\n  color: var(--message-grey-color);\n  font-size: 13px;\n}\n.acs-status .acs-status-left[data-v-6335f684] {\n  display: flex;\n  flex-direction: column;\n  align-self: start;\n  flex-grow: 1;\n}\n.acs-status .acs-status-left .status[data-v-6335f684] {\n  color: var(--message-grey-color);\n}\n.acs-status .acs-status-left .status.color-accent[data-v-6335f684] {\n  color: #2977c2;\n}\n.acs-status .acs-status-left.verbose[data-v-6335f684] {\n  margin: auto 0 auto 20px;\n  line-height: normal;\n  font-size: 1.2em;\n  color: #2977c2;\n}\n.acs-status .acs-status-right[data-v-6335f684] {\n  display: flex;\n  flex-direction: column;\n  align-self: end;\n  text-align: center;\n  color: var(--message-grey-color);\n  font-size: 0.9em;\n  height: 100%;\n}\n.acs-status .acs-status-right.verbose[data-v-6335f684] {\n  margin-right: 20px;\n  font-size: 1.2em;\n}\n.acs-status .acs-status-right .head[data-v-6335f684] {\n  white-space: pre;\n  margin: auto;\n}\n.acs-status .acs-link[class*=\"acs-link\"][data-v-6335f684] {\n  margin: auto 0 auto 20px;\n}\n.acs-status .acs-link[class*=\"acs-link\"] i[data-v-6335f684] {\n  display: flex;\n  margin-right: auto;\n  color: var(--message-grey-color);\n  font-size: 20px;\n}\n.acs-status .entraces-toggle[class*=\"entraces-toggle\"][data-v-6335f684] {\n  display: flex;\n  margin: auto;\n  border-radius: 50%;\n  background-color: var(--asc-item-border-bottom);\n  padding: 6px;\n  width: 30px;\n  height: 30px;\n}\n.acs-status .entraces-toggle[class*=\"entraces-toggle\"] i[data-v-6335f684] {\n  margin: auto;\n  font-size: 14px;\n}\n.acs-spinner-wrapper[data-v-6335f684] {\n  display: flex;\n  min-height: 58px;\n  width: 100%;\n  margin: auto;\n  background-color: inherit;\n}\n.acs-spinner-wrapper .acs-spinner[data-v-6335f684] {\n  display: flex;\n  margin: auto;\n}\n.acs-status-info[data-v-6335f684] {\n  padding: 0;\n}\n.acs-verbose[data-v-6335f684] {\n  border-bottom: 1px solid var(--asc-item-border-bottom);\n  height: 58px;\n}\n.acs-status-placeholder[data-v-6335f684] {\n  color: #ccc;\n}\n.additional-block[data-v-6335f684] {\n  padding: 20px 40px;\n}\n.acs-status[data-v-6335f684]:not(:last-child),\n.additional-block[data-v-6335f684]:not(:last-child) {\n  box-shadow: none;\n}\n.acs-spinner i[data-v-6335f684] {\n  font-size: 18px;\n  font-weight: lighter;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
